export default __webpack_public_path__ + "assets/images/0876911f99cd82ab816d095e73913316.svg";